import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./state/store";
import { BrowserRouter as Router } from "react-router";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import theme from "./utils/theme";
import httpService from "./services/httpService";

const { colors } = theme;

const token = localStorage.getItem("authToken");
if (token) {
	httpService.setAuthToken(token);
}

const muiTheme = createTheme({
	palette: {
		primary: {
			main: colors.primary,
		},
		"primary-subtle": {
			main: "#FF0000", // Rojo
		},
		secondary: {
			main: colors.secondary,
		},
	},
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
	<React.StrictMode>
		<Provider store={store}>
			<Router>
				<ThemeProvider theme={muiTheme}>
					<App />
				</ThemeProvider>
			</Router>
		</Provider>
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(consle.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
